import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { BASE_API } from "Api"
import { Notification } from "Helpers/actions"


export const addToCart = createAsyncThunk(
  "addToCart",
  async ({ course_id , type }, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await BASE_API.post("/user/cart", { course_id: course_id , type: type });
      return fulfillWithValue(response?.data?.data);
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const addToFavourites = createAsyncThunk(
  "addToFavourites",
  async ({ course_id , type }, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await BASE_API.post("/user/favourites", { course_id: course_id , type: type });
      return fulfillWithValue(response?.data);
    } catch (error) {
      return rejectWithValue(error?.response);
    }
  }
);

const initialState = {
  data: {}
}

export const cart = createSlice({
  name: 'cart',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
    .addCase(addToCart.fulfilled, (state, action) => {
      Notification('Added To Cart' , 2500 , 'success')
      // state.data = action.payload
    }) 
    .addCase(addToCart.rejected, (state , action) => {
      const message = action.payload?.message || 'Network Error'
      Notification(message)
    }) 
    .addCase(addToFavourites.fulfilled, (state, action) => {
      const message = action.payload?.message || 'Success'
      Notification(message , 2500 , 'success')
    }) 
    .addCase(addToFavourites.rejected, (state , action) => {
      const message = action.payload?.message || 'Network Error'
      Notification(message)
    }) 
  }
})

export default cart.reducer